// import React, { useEffect, useState } from 'react'
// import Hero from '../Components/Hero/Hero'
// import Popular from '../Components/Popular/Popular'
// import Offers from '../Components/Offers/Offers'
// import NewCollections from '../Components/NewCollections/NewCollections'
// import NewsLetter from '../Components/NewsLetter/NewsLetter'

// const Shop = () => {

//   const [popular, setPopular] = useState([]);
//   const [newcollection, setNewCollection] = useState([]);
  
//   // const fetchInfo = () => { 
//   //   fetch('http://localhost:4000/popularinwomen') 
//   //           .then((res) => res.json()) 
//   //           .then((data) => setPopular(data))
//   //   fetch('http://localhost:4000/newcollections') 
//   //           .then((res) => res.json()) 
//   //           .then((data) => setNewCollection(data))
//   //   }

//   //   useEffect(() => {
//   //     fetchInfo();
//   //   }, [])


//   return (
//     <div>
//       <Hero/>
//       <Popular/>
//       {/* <Offers/> */}
//       {/* <NewCollections/> */}
//       <NewsLetter/>
//     </div>
//   )
// }

// export default Shop



import React from "react";
import Hero from "../Components/Hero/Hero";
import Popular from "../Components/Popular/Popular";
import NewsLetter from "../Components/NewsLetter/NewsLetter";

const Shop = () => {
  // Mock data for Popular
  const popularMock = [
    { id: 1, title: "AI Development", category: "ai" },
    { id: 2, title: "Tech Production", category: "tech" },
    { id: 3, title: "Media Expert", category: "media" },
  ];

  return (
    <div>
      <Hero />
      <Popular popularItems={popularMock} /> pass mock data
      <NewsLetter />
    </div>
  );
};

export default Shop;
